import {
  getPbPageServerSideProps,
  PageBuilderDesktop,
} from 'modules/page-builder';

export const getServerSideProps: GetServerSideProps = ((context) =>
  context?.req?.tenantEnv?.epicPb1887 ||
  context?.req?.tenantEnv?.epicEcom480 ||
  context?.req?.tenantEnv?.showPbPagesFromWebsiteEditor
    ? getPbPageServerSideProps(context, context.query.slug as string)
    : { notFound: true }) as GetServerSideProps;
export default PageBuilderDesktop;
